import { render, staticRenderFns } from "./SupportTabs.vue?vue&type=template&id=ab00a574&"
import script from "./SupportTabs.vue?vue&type=script&lang=js&"
export * from "./SupportTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports